export default __webpack_public_path__ + "static/media/oddman.fa082472.png";